<template>
  <div id="TaskTypeManagement" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <el-input
          @keyup.enter.native="handleFilter"
          size="small"
          type="primary"
          :placeholder="$t('searchForTheTaskTypeName')"
          clearable
          v-model.trim="keywords"
          data-cy="inputSerach"
          class="w-200px mr-10px"
        ></el-input>
        <el-button type="primary" @click="handleFilter" data-cy="searchBtn">{{
          $t('search')
        }}</el-button>
        <el-button
          :disabled="!$hasAccess('create')"
          type="primary"
          @click="taskType()"
          data-cy="addBtn"
          >{{ $t('create') }}</el-button
        >
        <el-button
          :disabled="!$hasAccess('open') || !display"
          type="primary"
          @click="handleBatch('open')"
          >{{ $t('open') }}</el-button
        >
        <el-button
          :disabled="!$hasAccess('stop') || !display"
          type="danger"
          @click="handleBatch('stop')"
          >{{ $t('deactivate') }}</el-button
        >
      </el-row>
      <div style="height: calc(100% - 57px)" class="mt-20px">
        <el-table
          key="auth"
          :data="tabList"
          v-loading="listLoading"
          border
          class="w-full cur_pointer"
          :highlight-current-row="true"
          @row-dblclick="editRow"
          @selection-change="selectionChange"
          @sort-change="sortChange"
          height="height: calc(100% - 42px)"
          style="height: calc(100% - 42px)"
          stripe
          row-key="id"
          ref="table"
        >
          <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
          <el-table-column
            prop="name"
            sortable="custom"
            :label="$t('taskTypeName')"
            min-width="130"
          ></el-table-column>
          <el-table-column prop="status" sortable="custom" :label="$t('status')" width="75">
            <template slot-scope="scope">{{
              scope.row.status === 1 ? `${$t('deactivated')}` : `${$t('oning')}`
            }}</template>
          </el-table-column>
          <el-table-column
            prop="description"
            sortable="custom"
            :label="$t('description')"
            min-width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="priority"
            sortable="custom"
            :label="$t('priority')"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            sortable="custom"
            :label="$t('startTime')"
            min-width="105"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.startTime
                    ? dayjs(scope.row.startTime).format('YYYY/MM/DD HH:mm:ss')
                    : `${$t('noDateYet')}`
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" sortable="custom" :label="$t('endTime')" min-width="105">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.endTime
                    ? dayjs(scope.row.endTime).format('YYYY/MM/DD HH:mm:ss')
                    : `${$t('noDateYet')}`
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdTime"
            sortable="custom"
            :label="$t('createTime')"
            min-width="105"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.createdTime
                    ? dayjs(scope.row.createdTime).format('YYYY/MM/DD HH:mm:ss')
                    : `${$t('noDateYet')}`
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastModifiedTime"
            sortable="custom"
            min-width="130"
            :label="$t('lastModifiedTime')"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.lastModifiedTime
                    ? dayjs(scope.row.lastModifiedTime).format('YYYY/MM/DD HH:mm:ss')
                    : `${$t('noDateYet')}`
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="triggerTime"
            :label="$t('triggerInterval')"
            width="100"
          ></el-table-column>
          <el-table-column :label="$t('operate')" min-width="150" prop="status" fixed="right">
            <template slot-scope="scope">
              <el-button
                :disabled="!$hasAccess('update')"
                size="mini"
                @click="editRow(scope.row)"
                >{{ $t('edit') }}</el-button
              >
              <el-button
                :disabled="!$hasAccess('stop')"
                size="mini"
                @click="handleOpenOrStop(scope.row)"
                data-cy="switch"
                >{{ scope.row.status === 1 ? $t('open') : $t('deactivate') }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-20px float-right">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNo"
            :page-sizes="$pageSizeAll"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordCount"
          ></el-pagination>
        </div>
      </div>
      <div style="height: calc(100% - 57px)" class="mt-20px" v-if="false">
        <el-table border key="noAuth" stripe height="100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="name"
            sortable="custom"
            :label="`${$t('taskTypeName')}`"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="status"
            sortable="custom"
            :label="`${$t('state')}`"
            width="75"
          ></el-table-column>
          <el-table-column
            prop="description"
            sortable="custom"
            :label="`${$t('describe')}`"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="priority"
            sortable="custom"
            :label="`${$t('Priority')}`"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            sortable="custom"
            :label="`${$t('startTime')}`"
            min-width="105"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            sortable="custom"
            :label="`${$t('endTime')}`"
            min-width="105"
          ></el-table-column>
          <el-table-column
            prop="createdTime"
            sortable="custom"
            :label="`${$t('creationTime')}`"
            min-width="105"
          ></el-table-column>
          <el-table-column
            prop="lastModifiedTime"
            sortable="custom"
            min-width="130"
            :label="`${$t('lastModifiedTime')}`"
          ></el-table-column>
          <el-table-column
            prop="triggerTime"
            :label="`${$t('firingInterval')}`"
            width="100"
          ></el-table-column>
          <el-table-column
            :label="`${$t('operate')}`"
            min-width="64"
            prop="status"
          ></el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 编辑与新建公用dialog -->
    <el-dialog
      :title="titleDialog === 'add' ? $t('createANewTaskType') : $t('editTheTaskType')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="small-dialog"
      :before-close="closeDialog"
      :lock-scroll="true"
      data-cy="editDialog"
      v-dialogDrag
    >
      <el-form :rules="rules" ref="formDetail" label-width="150px" :model="formDetail">
        <el-form-item :label="$t('name')" prop="name">
          <el-input v-model.trim="formDetail.name" clearable data-cy="name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('code')" prop="type">
          <el-input
            v-model.trim="formDetail.type"
            :disabled="isDisabled"
            clearable
            data-cy="type"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('description')" prop="description">
          <el-input
            v-model.trim="formDetail.description"
            clearable
            data-cy="description"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('priority')" prop="priority">
          <el-input
            v-model.number="formDetail.priority"
            maxlength="9"
            clearable
            data-cy="priority"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('startTime')" prop="startTime" class="datePicker">
          <el-date-picker
            v-model="formDetail.startTime"
            type="datetime"
            :placeholder="`${$t('selectStartTime')}`"
            clearable
            class="!w-440px"
            value-format="yyyy/MM/dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('endTime')" prop="endTime" class="datePicker">
          <el-date-picker
            v-model="formDetail.endTime"
            type="datetime"
            :placeholder="`${$t('selectEndTime')}`"
            clearable
            class="!w-440px"
            value-format="yyyy/MM/dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('triggerInterval')" prop="triggerTime">
          <el-input v-model="formDetail.triggerTime" clearable data-cy="triggerTime"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('formDetail')">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="handleAddOrEdit(formDetail, titleDialog)">{{
          $t('save')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import ApiMixinTaskType from '@/assets/js/api/taskType'
import fnMixin from '@/assets/js/fnMixins'

export default {
  name: 'TaskTypeManagement',
  data() {
    return {
      listLoading: false,
      dialogVisible: false,
      keywords: null, // 搜索的内容
      sortName: 'last_modified_time', // 排序的字段
      sortType: 'desc', // 排序的方式 asc为升序, desc为降序
      pageNo: 1, // 当前的页
      pageSize: 15, // 当前的页显示数据的条数
      recordCount: 0, // 分页的总数
      tabList: [], // tab列表的数据
      formDetail: {
        id: null,
        name: null,
        type: null,
        description: null,
        priority: null,
        startTime: null,
        endTime: null,
        triggerTime: null,
      }, // 新增、编辑属性的数据
      editList: {},
      addList: {},
      selectRow: [], // 当前选中的行
      display: false,
      isDisabled: false,
      titleDialog: null,
      rules: {
        name: [{ required: true, message: `${this.$t('enterTaskTypeName')}`, trigger: 'change' }],
        type: [{ required: true, message: `${this.$t('enterTaskTypeCode')}`, trigger: 'change' }],
        description: [
          { required: true, message: `${this.$t('enterTaskTypeDes')}`, trigger: 'change' },
        ],
        priority: [
          { required: true, message: `${this.$t('enterTaskTypePriority')}`, trigger: 'change' },
          { type: 'number', message: '只能输入数字', trigger: 'change' },
        ],
        triggerTime: [
          { required: true, message: `${this.$t('enterTimeInterval')}`, trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    // tab列表的数据请求的方法
    async handleGetTabListMethod() {
      this.listLoading = true
      const params = {
        Name: this.keywords || ' ',
        SkipCount: (this.pageNo - 1) * this.pageSize, // 跳过条数
        MaxResultCount: this.pageSize,
        Sorting: `${this.sortName} ${this.sortType}`,
      }
      const dataList = await this.apiTaskType({
        method: 'list',
        params,
      })
      if (dataList && dataList.code === 0 && dataList.data) {
        this.listLoading = false
        this.recordCount = dataList.totalCount
        return dataList.data
      }
      this.listLoading = false
      return []
    },
    // 批量开启、停用共用方法
    handleBatch(setStatus) {
      const status = setStatus === 'open' ? '开启' : '停用 '
      if (this.selectRow && this.selectRow.length > 0) {
        this.$confirm(`此操作将进行批量${status}, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const selectList = _.map(this.selectRow, (i) => {
              return {
                id: i.id,
                description: i.description,
                name: i.name,
                priority: i.priority,
                type: i.type,
                startTime: i.startTime,
                endTime: i.endTime,
                triggerTime: i.triggerTime,
                status: setStatus === 'open' ? 0 : 1,
              }
            })
            this.batchOpenOrStop(selectList, status)
          })
          .catch(() => {})
      } else {
        this.$alert(`请勾选需要${status}的项`, '提示', {
          confirmButtonText: '确定',
          callback: () => {},
        })
      }
    },
    // 开启、停用发送的请求(批量)
    async batchOpenOrStop(params, status) {
      const batchList = await this.apiTaskType({
        method: 'batch',
        params,
      })
      if (batchList && batchList.code === 0) {
        this.$message({
          type: 'success',
          message: `${status}成功`,
          duration: 2000,
        })
        this.tabList = await this.handleGetTabListMethod()
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      } else {
        this.$message({
          type: 'warning',
          messsage: batchList.message,
          duration: 2000,
        })
      }
    },
    // 点击某一行开启或者停用
    handleOpenOrStop(row) {
      const data = { ...row }
      data.status = row.status === 1 ? 0 : 1
      const type = row.status === 1 ? '开启' : '停用'
      this.$confirm(`此操作将进行${type}，是否继续`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.operateTaskListMethod(data, type)
      })
    },
    // 开启、停用发送的请求(单个)
    async operateTaskListMethod(params, type) {
      const updateList = await this.apiTaskType({
        method: 'update',
        params,
      })
      if (updateList && updateList.code === 0 && updateList.data) {
        this.$message({
          type: 'success',
          message: `${type}成功`,
          duration: 2000,
        })
        this.tabList = await this.handleGetTabListMethod()
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      } else {
        this.$message({
          type: 'warning',
          messsage: updateList.message,
          duration: 2000,
        })
      }
      return updateList
    },
    // 新增方法
    taskType() {
      this.titleDialog = 'add'
      this.dialogVisible = true
    },
    // 编辑当前行
    editRow(row) {
      if (this.$hasAccess('update')) {
        this.titleDialog = 'edit'
        this.isDisabled = true
        _.assign(this.formDetail, row)
        this.dialogVisible = true
      } else {
        this.$alert('没有权限操作！', '', {
          confirmButtonText: '确定',
        })
      }
    },
    // 新增及编辑保存操作共用方法
    handleAddOrEdit(formDetail, type) {
      this.$refs.formDetail.validate((valid) => {
        if (valid) {
          const startTime = new Date(formDetail.startTime).getTime()
          const endTime = new Date(formDetail.endTime).getTime()
          if (startTime > endTime) {
            this.$message.warning('开始时间不能大于结束时间')
            return
          }
          if (type === 'add') {
            _.assign(this.addList, formDetail)
            this.handleAddMethod(this.addList)
          } else {
            _.assign(this.editList, formDetail)
            this.handleEditMethod(this.editList)
          }
        } else {
          this.$message({
            type: 'warning',
            message: '请按提示正确填写',
            duration: 2000,
          })
        }
      })
    },
    // 编辑更新请求
    async handleEditMethod(params) {
      const edit = await this.apiTaskType({
        method: 'edit',
        params,
      })
      if (edit && edit.code === 0) {
        this.$message({
          type: 'success',
          message: '保存成功',
          duration: 2000,
        })
        this.tabList = await this.handleGetTabListMethod()
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
        this.closeDialog()
      } else {
        // this.$message({
        //   type: 'warning',
        //   message: edit.message,
        //   duration: 2000,
        // })
      }
      return edit
    },
    // 新增操作请求
    async handleAddMethod(params) {
      const create = await this.apiTaskType({
        method: 'create',
        params,
      })
      if (create && create.code === 0 && create.data) {
        this.$message({
          type: 'success',
          message: '保存成功',
          duration: 2000,
        })
        this.tabList = await this.handleGetTabListMethod()
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
        this.closeDialog()
      } else {
        // this.$message({
        //   type: 'warning',
        //   message: create.message,
        //   duration: 2000,
        // })
      }
      return create
    },
    // 当用户点击关闭图标调用
    closeDialog() {
      this.$refs.formDetail.resetFields()
      this.dialogVisible = false
      this.isDisabled = false
      this.formDetail = {
        id: null,
        name: null,
        type: null,
        description: null,
        priority: null,
        startTime: null,
        endTime: null,
        triggerTime: null,
      }
    },
    async handleSizeChange(val) {
      this.pageSize = val
      this.tabList = await this.handleGetTabListMethod()
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    // 分页
    async handleCurrentChange(val) {
      this.pageNo = val
      this.tabList = await this.handleGetTabListMethod()
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    // 勾选要操作的数据
    selectionChange(val) {
      this.selectRow = val
      this.display = this.selectRow && this.selectRow.length
    },
    // 按下回车键搜索、 搜索功能
    async handleFilter() {
      this.pageNo = 1
      this.tabList = await this.handleGetTabListMethod()
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    // 排序
    async sortChange(column) {
      if (column.column === null) {
        return
      }
      this.sortName = fnMixin.methods.humpToUnderline(column.prop)
      if (column.order === 'ascending') {
        this.sortType = 'asc'
        this.tabList = await this.handleGetTabListMethod()
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      } else {
        this.sortType = 'desc'
        this.tabList = await this.handleGetTabListMethod()
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      }
    },
  },
  watch: {
    tabList(val) {
      // console.log('tab新值', val)
    },
  },
  async created() {
    this.tabList = await this.handleGetTabListMethod()
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  mixins: [ApiMixinTaskType],
}
</script>
<style scoped>

.datePicker .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

</style>
